<template>
  <div class="is-block map-wrapper" v-show="showMap" >
    <div class="google-map" id="google-map" :class="{ 'is-hidden': !showMap}"></div>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    showMap: {
      type: Boolean,
      default: false
    },
    coord: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      mapName: "google-map"
    };
  },
  mounted() {
      this.initMap()
  },
  methods: {
    initMap() {
      if (this.coord) {
        const element = document.getElementById(this.mapName);
        if (!element) return;
        // console.log('which map element', element);
        const options = {
          zoom: 14,
          center: new google.maps.LatLng(this.coord.lat, this.coord.lng),
          mapTypeControl: false,
          streetViewControl: false,
        //   disableDefaultUI: true
        };
        const map = new google.maps.Map(element, options);

        const position = new google.maps.LatLng(this.coord.lat, this.coord.lng);
        const marker = new google.maps.Marker({
          position,
          map
        });
      }
    }
  },
  beforeDestroy() {

  }
};
</script>

<style lang="scss" scoped>
.google-map {
  height: 240px;
  width: 100%;
  background-color: $white-ter;
  transition: all 200ms ease-out;
}

.google-map.is-hidden {
  height: 0;
}
</style>